import { Children } from 'react'
import styles from './_storeProductsBanner.module.scss'
import classNames from 'classnames'

interface StoreProductsBannerProps {
  title: string
  children?: React.ReactNode
}
const StoreProductsBanner: React.FC<StoreProductsBannerProps> = ({
  title,
  children
}) => {
  const [icon, bgImg, contentImg] = Children.toArray(children)

  return (
    <div className={classNames('section', styles.storeProductsBanner)}>
      <div className="container">
        <div
          className={classNames(styles.storeProductsBannerSection, 'columns')}
        >
          <div
            className={classNames(
              styles.storeProductsBannerTitle,
              'column is-12-mobile is-7-tablet is-5-desktop'
            )}
          >
            {icon}
            <h1>{title}</h1>
          </div>
          <div className={classNames('column', styles.contentImgContainer)}>
            {contentImg}
          </div>
        </div>
      </div>
      <div className={styles.storeProductsBannerImgContainer}>{bgImg}</div>
    </div>
  )
}

export default StoreProductsBanner
